import { z } from 'zod'

/** Stored OneTrust webhook body (Profile Updated event as-is). Mapping happens in the consumer. */
export const onetrustEventSchema = z.record(z.string(), z.unknown())

export type CreateOneTrustEvent = z.infer<typeof onetrustEventSchema>
export type OneTrustEvent = z.infer<typeof onetrustEventSchema>
